import React from "react";
import { Clock, Star, MapPin } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1687764628150-1dc8afa7ba52?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

// Premium split-screen wrapper shared by all auth/onboarding entry screens.
export function AuthShell({ children, maxWidth = "440px", align = "center" }) {
  return (
    <div className="min-h-screen flex bg-surface">
      <div className="relative hidden lg:flex lg:w-[45%] overflow-hidden">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-coral/90 via-coral/60 to-red-800/85" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/20" />
        <div className="relative z-10 flex flex-col justify-between w-full p-10 xl:p-14 text-white">
          <div className="flex items-center gap-3">
            <img src="/bitego-icon.png" alt="BiteGoFood" className="w-12 h-12 rounded-2xl shadow-lg ring-1 ring-white/30" />
            <span className="font-display font-extrabold text-2xl tracking-tight">BiteGoFood</span>
          </div>
          <div className="max-w-md">
            <h1 className="font-display font-extrabold text-4xl xl:text-5xl leading-[1.05] tracking-tight drop-shadow">Food Near You,<br />Faster Than Ever.</h1>
            <p className="mt-4 text-white/85 text-base leading-relaxed">Order from the best restaurants around you — delivered hot, fresh and lightning fast.</p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {[[Clock, "30 min delivery"], [MapPin, "500+ restaurants"], [Star, "Live order tracking"]].map(([Icon, label]) => (
                <span key={label} className="inline-flex items-center gap-1.5 bg-white/15 backdrop-blur-md border border-white/20 rounded-full px-3.5 py-2 text-sm font-semibold">
                  <Icon size={15} /> {label}
                </span>
              ))}
            </div>
          </div>
          <p className="text-white/60 text-xs">A Product by Vijay Software Solutions Pvt Ltd</p>
        </div>
      </div>

      <div className={`flex-1 lg:w-[55%] flex flex-col items-center px-5 sm:px-8 py-8 ${align === "center" ? "justify-center" : "justify-start"}`}>
        <div className="w-full" style={{ maxWidth }}>{children}</div>
      </div>
    </div>
  );
}

// Compact brand block shown on mobile/tablet (the hero panel is hidden below lg).
export function AuthBrandHeader() {
  return (
    <div className="lg:hidden flex flex-col items-center text-center mb-6">
      <img src="/bitego-icon.png" alt="BiteGoFood" className="w-20 h-20 rounded-3xl shadow-md" />
      <h1 className="mt-3 font-display font-extrabold text-2xl text-ink tracking-tight">BiteGoFood</h1>
      <p className="text-ink-600 text-sm">Food Near You, Faster Than Ever.</p>
    </div>
  );
}
